<template>
  <div class="main-layout">
    <CCollapseItem>
      <template slot="title-left"> 测试题库</template>
      <template slot="body">
        <c-search
          v-model="pageParams"
          :searchItems="searchItems"
          @reset="refresh"
          @search="pageGet(true)"
        >
        </c-search>
      </template>
    </CCollapseItem>
    <el-card class="box-table box-bottom">
      <div slot="header" class="btn-group">
        <!-- 操作按钮 -->
        <div class="btn-left">
          <div class="opt-btn" title="新增" @click="goto('')">
            <i class="iconfont icon-add"></i>
          </div>
        </div>
        <!-- 右侧操作按钮 -->
        <table-btns
          :tableColumns="tableColumns"
          @tableColumnsChange="tableColumnsChange"
          @refresh="pageGet(true)"
        ></table-btns>
      </div>
      <c-table
        :data="pageData"
        :tableColumns="tableColumns"
        :pagination="pageParams"
        @change="pageGet"
        @selectionChange="selectionChange"
        @edit="goto"
        @showDetail="gotoDetail"
        @delete="pageDel"
        v-loading="pageLoading"
      >
        <template slot="status" slot-scope="scope">
          <span
            :class="{
              red: scope.row.isGet == 0,
              green: scope.row.isGet == 1,
            }"
          >
            {{ scope.row.isGet == 0 ? "否" : scope.row.isGet == 1 ? "是" : "" }}
          </span>
        </template>
      </c-table>
    </el-card>
  </div>
</template>

<script>
import MPage from "@/mixins/MPage.js";
import Configs from "./data/question";
import { mapState } from "vuex";
let mPage = MPage({
  pagePath: "/welcome-forecast/test/title/listPage",
  pageDelPath: "/welcome-forecast/test/title",
  pageDelsPath: "",
  pageParams: {
    name: "",
    templateId: "",
    dimension: "",
  },
  pageExportPath: "",
  pageExportParams: {},
});
export default {
  mixins: [mPage],
  name: "",
  data() {
    let { searchItems, tableColumns, formItems, formRules } = Configs(this);
    return {
      isFold: false,
      searchItems,
      tableColumns,
      formItems,
      formRules,
      title: "",
      idList: [],
      isExport: false,
      message: null,
      dialogVisible: false,
      importHeader: {},
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE"]),
  },
  created() {
    let token = localStorage.getItem("token");
    this.importHeader = { token };
  },
  mounted() {},
  methods: {
    goto(data) {
      let id = data.id;
      // 新增
      this.$router.push("/welcome/teacher/entranceTest/questionAdd/" + id);
    },
    gotoDetail(data) {
      let id = data.id;
      this.$router.push("/welcome/teacher/entranceTest/questionView/" + id);
    },
    selectionChange(data) {
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.studentId);
        });
        this.idList = idList;
      }
    },
    handleDelBatch() {
      if (this.idList.length) {
        this.pageDels(this.idList);
      } else {
        this.$message({
          message: "请选择需要删除的数据！",
          type: "warning",
        });
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
    },
    refresh() {
      this.idList = [];
      this.pageParams = {
        name: "",
        templateId: "",
        dimension: "",
      };
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    exportExcel() {
      if (this.isExport) {
        return;
      } else {
        this.isExport = true;
        this.message = this.$message({
          message: "数据正在导出中，请稍候！",
          duration: 0,
          type: "warning",
          center: true,
        });
        this.pageExportParams = Object.assign({}, this.pageParams);
        if (this.idList.length) {
          this.pageExportParams.studentIdStr = this.idList.join();
        }
        this.pageExport();
      }
    },
    pageExportAfterFn() {
      this.isExport = false;
      this.message.close();
      this.message = null;
      this.refresh();
      this.pageExportParams = {};
    },
  },
};
</script>

